import { Api } from '@/services/Api';

export default {
  /*  1. Get all data */
  getAppointmentsByCriteria(body = { keyword: '' }) {
    return Api().post('/Appointments/GetAppointmentsByCriteria', body);
  },
  /*  2. Get one column */
  getAppointments(id) {
    return Api().get(`/Appointments/${id}`);
  },
  /*  3. Create one column */
  saveAppointments(body) {
    return Api().post(`/Appointments`, body);
  },
  /*  4. Delete one or more columns */
  deleteAppointments(body) {
    return Api().post(`/Appointments/DeleteAppointments`, body);
  },
  /*  5. post one or more columns */
  postAppointments(body) {
    return Api().post(`/Appointments/PostAppointments`, body);
  }
};
